<div class="claim-search wrapper ssp">
  <div class="mobile">
    <div class="toolbar">
      <div class="left">Recent Claims Activity</div>
      <div class="right">
        <mat-icon class="white-icon" (click)="toggleSearchBar()">search</mat-icon>
        <div class="vertical-divider"></div>
        <img class="white" (click)="openExport()" src="../../../../assets/images/download_icon.png">
      </div>
    </div>

    <div class="search-bar" *ngIf="showSearchBar">
      <form [formGroup]="searchForm">
        <mat-form-field class="search-category mr-3">
          <mat-label>{{ 'claims.list.component.toolbar.category' | translate }}</mat-label>
          <mat-select formControlName="category" (openedChange)="toggleSelect()">
            <mat-option *ngFor="let option of getFilteredSearchCategories()" [value]="option.value">{{ option.label }}</mat-option>
          </mat-select>
          <mat-icon matSuffix *ngIf="!matSelectIsOpen">keyboard_arrow_down</mat-icon>
          <mat-icon matSuffix *ngIf="matSelectIsOpen">keyboard_arrow_up</mat-icon>
        </mat-form-field>

        <mat-form-field [floatLabel]="'never'" class="search-input">
          <input matInput (keyup)="trim()" formControlName="searchVal">
          <mat-icon matPrefix class="custom-margin pointer">search</mat-icon>
          <mat-icon matSuffix class="pointer" (click)="reset()" *ngIf="searchVal.enabled">close</mat-icon>
        </mat-form-field>

        <button *ngIf="!loading" (click)="search()" class="upsc-primary-button icon-right">Search<mat-icon>chevron_right</mat-icon></button>
        <button *ngIf="loading" class="upsc-primary-button icon-right" disabled>Search<span class="spinner-border"></span></button>
      </form>
    </div>
  </div>
  <div class="desktop">
    <div class="search-bar">
      <form [formGroup]="searchForm">
        <div class="left">
          <mat-form-field class="search-category mr-3">
            <mat-label>{{ 'claims.list.component.toolbar.category' | translate }}</mat-label>
            <mat-select formControlName="category" (openedChange)="toggleSelect()">
              <mat-option *ngFor="let option of getFilteredSearchCategories()" [value]="option.value">{{ option.label }}</mat-option>
            </mat-select>
            <mat-icon matSuffix *ngIf="!matSelectIsOpen">keyboard_arrow_down</mat-icon>
            <mat-icon matSuffix *ngIf="matSelectIsOpen">keyboard_arrow_up</mat-icon>
          </mat-form-field>

          <mat-form-field [floatLabel]="'never'" class="search-input">
            <input matInput (keyup)="trim()" formControlName="searchVal">
            <mat-icon matPrefix class="custom-margin pointer">search</mat-icon>
            <mat-icon matSuffix class="pointer" (click)="reset()" *ngIf="searchVal.enabled">close</mat-icon>
          </mat-form-field>
          <button *ngIf="!loading" (click)="search()" class="upsc-primary-button icon-right">Search<mat-icon>chevron_right</mat-icon></button>
          <button *ngIf="loading" class="upsc-primary-button icon-right" disabled>Search<span class="spinner-border"></span></button>
        </div>
      </form>
      <div class="last-three-items">
        <div class="item-format pl-1" (click)="openExport()">
          <img src="../../../../assets/images/download_icon.png">
          <div class="pl-1">{{ 'claims.list.component.toolbar.download' | translate }}</div>
        </div>
      </div>
    </div>
  </div>
</div>